import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_auth/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/',
)({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/dashboard/organizations/$organizationId/settings/measuring-instruments/$measurementDeviceId/calibrations',
            params,
        });
    },
});

function RouteComponent() {
    return (
        null
    );
}
